export const wrapper = 'w-full flex flex-col justify-start items-start';
export const actionsWrapper =
  'w-full flex flex-row justify-start items-baseline mt-3';
export const buttonIconStyle = 'h-5 w-5 text-secondary mr-1';
